// extracted by mini-css-extract-plugin
export default {"container":"CN-z","darkBackground":"DN-z","whiteBackground":"EN-z","headerButton":"FN-z","calloutHeading":"GN-z","calloutSubHeading":"HN-z"};